import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12c5fbe4")

_pushScopeId("data-v-12c5fbe4")
const _hoisted_1 = { class: "new-weekdays" }
const _hoisted_2 = {
  key: 0,
  class: "filter mb-2"
}
const _hoisted_3 = { class: "filter-title mb-4 text-start" }
const _hoisted_4 = { class: "d-flex flex-sm-nowrap flex-wrap" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "form-group mb-0" }
const _hoisted_7 = { for: "filterStartDate" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, null, -1)
const _hoisted_9 = { class: "form-group mb-0" }
const _hoisted_10 = { for: "filterEndDate" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, null, -1)
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { for: "filterStartTime" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, null, -1)
const _hoisted_16 = { class: "form-group mb-0" }
const _hoisted_17 = { for: "filterEndTime" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, null, -1)
const _hoisted_19 = { class: "d-flex align-items-center align-self-end" }
const _hoisted_20 = { class: "search-button-wrapper" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_22 = { class: "show-all-clear-filter text-nowrap pl-15" }
const _hoisted_23 = { class: "d-flex justify-content-center pt-2" }
const _hoisted_24 = { class: "table mb-0" }
const _hoisted_25 = { class: "text-nowrap" }
const _hoisted_26 = { class: "text-nowrap" }
const _hoisted_27 = { class: "text-nowrap" }
const _hoisted_28 = { class: "text-nowrap" }
const _hoisted_29 = { class: "text-nowrap" }
const _hoisted_30 = { class: "align-middle text-nowrap" }
const _hoisted_31 = { class: "align-middle text-nowrap" }
const _hoisted_32 = { class: "align-middle text-nowrap" }
const _hoisted_33 = { class: "align-middle text-nowrap" }
const _hoisted_34 = {
  key: 0,
  class: "icon-f fs-9 icon-infinity"
}
const _hoisted_35 = {
  key: 1,
  class: "text-center my-2"
}
const _hoisted_36 = {
  key: 2,
  class: "text-center my-2 warning-green"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_TimeInput = _resolveComponent("TimeInput")
  const _component_WeekdaysSelect = _resolveComponent("WeekdaysSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showFilter)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('product.slots.filter.title')), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('product.slots.filter.from_date')), 1),
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.filter.startDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.startDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  style: {"min-width":"130px"}
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('product.slots.filter.to_date')), 1),
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.filter.endDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.endDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  style: {"min-width":"130px"}
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('product.slots.filter.from_time')), 1),
                _createVNode(_component_TimeInput, {
                  name: "filterStartTime",
                  modelValue: _ctx.filter.from,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.from = $event)),
                  placeholder: "00:00"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('product.slots.filter.to_time')), 1),
                _createVNode(_component_TimeInput, {
                  name: "filterEndTime",
                  modelValue: _ctx.filter.to,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.to = $event)),
                  placeholder: "00:00"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFilter()))
                }, [
                  _hoisted_21
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("span", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
                }, _toDisplayString(_ctx.$t('button.showAll')), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_WeekdaysSelect, {
              modelValue: _ctx.filter.daysOfWeek,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.daysOfWeek = $event)),
              withCheck: false,
              style: {"min-width":"350px"}
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("table", _hoisted_24, [
      _createVNode("thead", null, [
        _createVNode("tr", null, [
          _createVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('calendar.v3.modal.start_time')), 1),
          _createVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('calendar.v3.modal.duration')), 1),
          _createVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat_end.date')), 1),
          _createVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('calendar.v3.modal.weekdays')), 1),
          _createVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('calendar.v3.modal.limit.title')), 1)
        ])
      ]),
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredSlots || _ctx.slots, (slot) => {
          return (_openBlock(), _createBlock("tr", {
            key: slot.id
          }, [
            _createVNode("td", _hoisted_30, _toDisplayString(_ctx.formatDate(slot.startDate)) + " " + _toDisplayString(_ctx.formatTime(slot.startTime)), 1),
            _createVNode("td", _hoisted_31, _toDisplayString(_ctx.formatTime(slot.duration)), 1),
            _createVNode("td", _hoisted_32, _toDisplayString(slot.repeatEndDate ? _ctx.formatDate(slot.repeatEndDate) : '' /*$t('No repeat')*/), 1),
            _createVNode("td", null, [
              _createVNode(_component_WeekdaysSelect, {
                class: "sm",
                modelValue: slot.daysOfWeek,
                "onUpdate:modelValue": ($event: any) => (slot.daysOfWeek = $event),
                withCheck: false,
                readonly: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createVNode("td", _hoisted_33, [
              _createTextVNode(_toDisplayString(slot.limit) + " ", 1),
              (!slot.limit)
                ? (_openBlock(), _createBlock("i", _hoisted_34))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ]),
    (!_ctx.slots && _ctx.slots.length)
      ? (_openBlock(), _createBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('product.slots.warning.no-slots')), 1))
      : (_ctx.filteredSlots && !_ctx.filteredSlots.length)
        ? (_openBlock(), _createBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('product.slots.warning.no-filtered')), 1))
        : _createCommentVNode("", true)
  ]))
})